/**
 * @param items returns template components/groups/posts-group/posts-group--raw.twig
 */
type PostsResponse = {
  items: string
  isLoadMore: boolean
}

export type Parameters = {
  page: number
  limit?: number
  category?: string
  search?: string
  author?: string
  hashtag?: string
  newsletter?: string
}

class PostsClient {
  responseSettings = {
    method: "GET",
  }

  async list(parameters: Parameters) {
    console.log(parameters)
    const urlBase = "/api/article/list"
    const url = new URL(`${window.location.origin}${urlBase}`)

    for (const [key, value] of Object.entries(parameters)) {
      if (value) url.searchParams.append(key, String(value))
    }

    const response = await fetch(url.toString(), this.responseSettings)

    console.log(response)

    if (!response.ok) return null

    const data: PostsResponse = await response.json()

    console.log(data)

    return data
  }
}

export const postsClient = new PostsClient()
